import { getEnv } from 'env/env';

export const HeaderTastic = () => (
  <div className="container-fluid logo-div">
    <div className="d-flex">
      <a href={getEnv('NEXT_PUBLIC_EDX_LEARNER_DASHBOARD_URL')}>
        <img
          className="logo"
          src="https://edx-cdn.org/v3/prod/logo.svg"
          alt="edX logo"
        />
      </a>
    </div>
  </div>
);
